import { runWhenIdle } from "./gtag";

/**
 * Google Tag Manager.
 *
 * Carga siempre en produccion, sin esperar el aviso de cookies -mismo
 * criterio que gtag.js (src/services/gtag.ts)-. Antes esperaba a que el
 * visitante aceptara, pero eso rompia la deteccion automatica de Google
 * (Tag Assistant / "esta etiqueta no se ha detectado en las ultimas 48
 * horas"): ese chequeo es un crawler que nunca hace click en el banner, asi
 * que si el script solo se inyecta post-aceptacion, Google jamas lo ve. El
 * contenedor ya recibe las señales de Consent Mode via gtag (mismo
 * dataLayer): lo que cambia con la eleccion del visitante no es si GTM
 * carga, sino que permisos de almacenamiento tienen las etiquetas
 * configuradas adentro del contenedor.
 *
 * El script se pide recien cuando la pagina ya cargo y el navegador esta
 * ocioso (runWhenIdle, mismo criterio que gtag.js): son ~125 KB de terceros que
 * competian con el primer render. El Tag Assistant sigue detectandolo, porque
 * se inyecta en cada visita aunque nadie haga click.
 *
 * Nunca se llama desde entry-server: ese bundle corre en Node durante el
 * prerender de build y mandaria una "visita" fantasma por cada una de las 47
 * rutas generadas en cada build.
 *
 * El fallback sin JS (<noscript> con el iframe de ns.html) vive directo en
 * index.html: es markup estatico, no necesita el gate de produccion.
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const GTM_CONTAINER_ID = "GTM-N5JKFSS";

let started = false;

export function initGoogleTagManager(): void {
  if (!import.meta.env.PROD || started) return;
  started = true;

  // GTM lee el dataLayer como eventos: no necesita el comando `gtag("js")`
  // que habia aca -que ademas se empujaba con la forma equivocada (un Array
  // en vez de un objeto `arguments`), asi que gtm.js lo ignoraba-. El
  // contenedor arranca solo con el script de abajo.
  window.dataLayer = window.dataLayer || [];

  runWhenIdle(() => {
    if (document.querySelector('script[data-gtm="true"]')) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
    script.dataset.gtm = "true";
    document.head.appendChild(script);
  });
}
